/**
 * @generated SignedSource<<feb872116143b317ff9662d806c20ddc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminArchivedList_TeamRefetchQuery$variables = {
  after?: string | null;
  first?: number | null;
  id: string;
  query?: string | null;
};
export type TeamScheduleAdminArchivedList_TeamRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminArchivedScreenList_archiveRoutines">;
  } | null;
};
export type TeamScheduleAdminArchivedList_TeamRefetchQuery = {
  response: TeamScheduleAdminArchivedList_TeamRefetchQuery$data;
  variables: TeamScheduleAdminArchivedList_TeamRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleAdminArchivedList_TeamRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamScheduleAdminArchivedScreenList_archiveRoutines"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamScheduleAdminArchivedList_TeamRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "RoutineConnection",
                "kind": "LinkedField",
                "name": "archivedRoutines",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "orgIconUri",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "descriptionImages",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageSize",
                                "kind": "LinkedField",
                                "name": "sizes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "height",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "width",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "urlExpiresAt",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "thumbhash",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "descriptionFiles",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": [
                  "query"
                ],
                "handle": "connection",
                "key": "TeamScheduleAdminArchivedList_routines_archivedRoutines",
                "kind": "LinkedHandle",
                "name": "archivedRoutines"
              }
            ],
            "type": "Team",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3b5664e9bdfc0ffc5f061c7fa674916",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleAdminArchivedList_TeamRefetchQuery",
    "operationKind": "query",
    "text": "query TeamScheduleAdminArchivedList_TeamRefetchQuery(\n  $after: String\n  $first: Int\n  $query: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...TeamScheduleAdminArchivedScreenList_archiveRoutines\n    id\n  }\n}\n\nfragment AHImageStackComponent_Images on Image {\n  id\n  ...Image_image\n}\n\nfragment DescriptionContentFiles_files on File {\n  id\n  url\n  ...FileCollectionItem_File\n}\n\nfragment DescriptionContentMedia_Media on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  __typename\n}\n\nfragment FileCollectionItem_File on File {\n  name\n  id\n  url\n  type\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment RoutineOccasionDescriptionContent_Routine on Routine {\n  descriptionImages {\n    ...DescriptionContentMedia_Media\n    id\n  }\n  description\n  descriptionFiles {\n    ...DescriptionContentFiles_files\n    id\n  }\n}\n\nfragment RoutineOccasionScreenRoutineDescription_Routine on Routine {\n  title\n  isOrg\n  ...RoutineOccasionDescriptionContent_Routine\n}\n\nfragment TeamScheduleAdminArchivedScreenListItem_routine on Routine {\n  id\n  title\n  ...TeamScheduleRoutineListItemContent_Routine\n}\n\nfragment TeamScheduleAdminArchivedScreenList_archiveRoutines on Team {\n  id\n  archivedRoutines(first: $first, after: $after, query: $query) {\n    edges {\n      cursor\n      node {\n        id\n        ...TeamScheduleAdminArchivedScreenListItem_routine\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  title\n  isOrg\n  description\n  orgIconUri\n  isArchived\n  ...RoutineOccasionScreenRoutineDescription_Routine\n  descriptionImages {\n    ...AHImageStackComponent_Images\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "545cca4d3a4783f85e3e8bcb099a196c";

export default node;
